

let paoSearch = {
  extraParams: {
    MailQ: ""
  }
};

paoDetails.support.isMobileDevice = detectMobileDevice();

let scrollObj = true;
let responsiveObj = false;

if (paoDetails.support.isMobileDevice) {
  scrollObj = false;
  responsiveObj = {
    details: {
      type: "inline",
      display: $.fn.dataTable.Responsive.display.childRowImmediate
    }
  };
}

$.fn.dataTable.render.moment("MM/DD/YYYY", "en");

window.addEventListener("pageshow", function (e) {
  e.preventDefault();
  e.stopPropagation();

  let data = sessionStorage.getItem("DataTable_searchData");
  if (data) {
    data = JSON.parse(data);
    loadGrid(data);
  }
  e.returnValue = "";
}); 

function loadGrid(data) {
  let nameMaxLen = 35;
  let maxNames = 2;
  let names;
  let numNames;
  let numCols = data.cols.length;
  let numRows = data.rows.length;
  let tooltip = "";

  $("#gridsearchColumn").remove();
  $("#gridsearchColumn_hidden").remove();

  let dtClass =
    "display table table-bordered table-striped table-hover compact nowrap";

  $("#gridsearchContainer")
    .append('<div class="col-sm-12" id="gridsearchColumn"><table id="gridsearch" class="' +
      dtClass +
      '" cellspacing="0" width="100%" style="max-height:20vh;" ></table></div>'
    );

  $("#gridsearchContainer")
    .append('<div id="gridsearchColumn_hidden"><table id="grid_hidden"></table></div>'
    );

  for (let c = 0; c < numCols; c++) {
    if (data.cols[c].type) {
      switch (data.cols[c].type) {
        case "num": 
          data.cols[c].render = $.fn.dataTable.render.number(",", ".", 0, "");
          break;
        case "int": 
          data.cols[c].render = $.fn.dataTable.render.number("", "", 0, "");
          break;
        case "dec": 
          data.cols[c].render = $.fn.dataTable.render.number("", ".", 2, "");
          break;
      }
    }
    if (data.cols[c].delimited && data.cols[c].delimited === true) {
      for (let r = 0; r < numRows; r++) {
        if (data.rows[r][c] !== null) {
          let more_icon = "";

          let re = /^[;]/;
          data.rows[r][c] = data.rows[r][c].replace(re, "");

          re = /[;]$/;
          data.rows[r][c] = data.rows[r][c].replace(re, "");

          names = data.rows[r][c].split(";");
          tooltip = names.join("\n");

          if (names.length > maxNames) {
            numNames = names.length;

            for (let i = 0; i < names.length; i++) {
              if (names[i].length > nameMaxLen) {
                names[i] =
                  names[i].substr(0, nameMaxLen - 3).replace(/\s$/, "") + "...";
              }
            }
            if (numNames > maxNames + 1) {
              more_icon =
                "<i class='fas fa-exclamation-triangle' aria-hidden='true'></i> ";
              names = names.slice(0, maxNames + 1);
              names[maxNames] =
                "~;~" +
                (numNames - maxNames) +
                " more " +
                data.cols[c].show_more_label;
              numNames = maxNames + 1;
            }
            let more_tmp = "";
            let parenL = "";
            let parenR = "";
            for (let i = 0; i < numNames; i++) {
              more_tmp = "";
              parenL = "";
              parenR = "";
              if (more_icon.length > 0) {
                if (names[i].indexOf("~;~") > -1) {
                  more_tmp = more_icon;
                  names[i] = names[i].replace("~;~", "");
                  parenL = "(";
                  parenR = ")";
                }
                names[i] =
                  more_tmp +
                  parenL +
                  names[i].substr(0, nameMaxLen) + 
                  parenR;
              }
            }
            let title_icon = "<i class='fas fa-users' aria-hidden='true'></i> ";
            let str = '';
            if (more_tmp.length > 0) {
              let html_tooltip =
                "<ul class='tooltip-li'><li>" +
                data.rows[r][c].split(";").join("</li><li>") +
                "</li></ul>";
              let pop =
                '<div data-toggle="popover" title="' +
                title_icon +
                " " +
                data.cols[c].show_more_label +
                '" data-content="<div>' +
                html_tooltip +
                '</div>">' +
                names.join("<br/>") +
                "</div>";
              data.rows[r][c] = pop;
            } else {
              data.rows[r][c] = splitAndJoinDataRow(data.rows[r][c], names);
            }
          } else {
            for (let i = 0; i < names.length; i++) {
              if (names[i].length > nameMaxLen) {
                names[i] =
                  names[i].substr(0, nameMaxLen - 3).replace(/\s$/, "") + "...";
              }
            }
            if (names?.length > 0) {
              data.rows[r][c] = splitAndJoinDataRow(data.rows[r][c], names);
            } else {
              data.rows[r][c] = '';
            }
          }
        }
      }
    }
  } 

  function splitAndJoinDataRow(data_row, data_names) {
    let html_tooltip =
      "<ul class='tooltip-li'><li>" +
      data_row
        .split(";")
        .join("</li><li>") +
      "</li></ul>";

    let str = data_names
      .filter(name => name.trim() !== '')
      .join("<br/>");

    return `<div data-content="<div>${html_tooltip}</div>">${str}</div>`;
  }

  function formatExportFileName({ fileName: file_name, appendDate: append_date }) {
    let mDate = moment();
    if (append_date)
      file_name = `${file_name}_${mDate.format('MM-DD-YYYY')}`;

    return file_name;
  } 


  function getPDF(options) {
    return new Promise(function (resolve, reject) {
      let xhr = new XMLHttpRequest();
      xhr.open(options.method, options.url, true);
      xhr.responseType = 'arraybuffer';
      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          let responseArray = new Uint8Array(xhr.response);
          resolve(responseArray);
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText
          });
        }
      };
      xhr.onerror = function () {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      };
      if (options.headers) {
        Object.keys(options.headers).forEach(function (key) {
          xhr.setRequestHeader(key, options.headers[key]);
        });
      }
      let params = options.params;
      xhr.send(params);
    });
  } 

  function createDownloadLink(data, file_name) {
    return new Promise((resolve, reject) => {
      try {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          let blob = new Blob([data], { type: "application/pdf" });
          window.navigator.msSaveOrOpenBlob(blob, file_name);
          return;
        } else {

          let blob = new Blob([data], { type: 'application/pdf' }); 
          let blobURL = URL.createObjectURL(blob, file_name);

          setTimeout(() => {
            downloadFile(blobURL);
            window.URL.revokeObjectURL(blobURL);
          }, 1000);

          window.downloadFile = (url) => {
            if (
              window.downloadFile.isChrome ||
              window.downloadFile.isSafari ||
              window.downloadFile.isNetscape
            ) {
              let link = document.createElement('a');
              link.href = url;
              link.setAttribute('target', '_blank');

              if (link.download !== undefined) {
                link.download = file_name;
                link.innerHTML = file_name;
              }
              if (document.createEvent) {
                let event = new MouseEvent("click", {
                  bubbles: true,
                  cancelable: true,
                  view: window
                });
                link.dispatchEvent(event);
                resolve(true);
                return true;
              }
            } 

            if (url.indexOf('?') === -1) {
              url += '?download';
            }
            window.open(url, '_blank');
            resolve(true);
            return true;
          };
          window.downloadFile.isChrome = checkDeviceBrand('Chromium');
          window.downloadFile.isSafari = checkDeviceBrand('Safari');
          window.downloadFile.isNetscape = checkDeviceBrand('Firefox');
        }
      } catch (error) {
        reject(error);
        return false;
      }
    });
  } 

  function exportLabels(json) {
    return new Promise(function (resolve, reject) {
      getPDF({
        url: '/wp-content/themes/frontier-child/models/pao-model-bulkmail.php',
        method: 'POST',
        params: json,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      })
        .then((data) => {
          let promise1 = new Promise((resolve, reject) => {

            let obj = JSON.parse(json);
            if (checkDeviceBrand('Microsoft')) {
              resolve(createDownloadLink(data, obj.file_name));
            } else {
              createDownloadLink(data, obj.file_name);
            }
          });
          promise1.then(function (result) {
            resolve(result);
          });
          promise1.catch(function (result) {
            reject(result);
          });
        })
        .catch(function (result) {
          reject(result);
        });
    });
  } 



  $("#gridsearch").DataTable({
    data: data.rows,
    columns: data.cols,
    serverSide: false, 
    destroy: true,
    autoWidth: false,
    fixedColumns: false,
    deferRender: true,
    dom: 'Bfrtip',
    buttons: [
      {
        extend: 'pageLength',
        className: 'pao-dt-buttons'
      },
      {
        extend: 'collection',
        text: 'Export',
        className: 'pao-dt-buttons',
        autoClose: true,
        buttons: [
          {
            extend: 'excelHtml5',
            text: '<i class="far fa-file-spreadsheet"></i> Excel',
            titleAttr: 'Search Results',
            className: 'pao-dt-buttons',
            filename: function () {
              return formatExportFileName({ fileName: 'mcpa-search-export', appendDate: true });
            },
            exportOptions: {
              modifier: {
                selected: null
              },
              columns: ':visible',
              format: {
                body: function (data, row, column, node) {
                  return formatGridExport(data, column);
                }
              }
            } 
          },
          {
            extend: 'excelHtml5',
            text: '<i class="far fa-file-spreadsheet"></i> Excel w/Mailing Info',
            titleAttr: 'Export w/Mailing Info',
            className: 'pao-dt-buttons',
            action: function (e, dt, node, config) {
              if (paoSearch.extraParams.MailQ === "") {
                paoSearch.extraParams.MailQ = "export";
                $("#searchform").submit();
              } else if (paoSearch.extraParams.MailQ === "exported") {
                config.header = true;
                config.footer = false;
                config.sheetName = formatExportFileName({ fileName: 'mcpa-mailing-labels', appendDate: true });
                config.title = null; 
                $.fn.dataTable.ext.buttons.excelHtml5.action.call(this, e, dt, node, config);
              }
            },
            filename: function () {
              return formatExportFileName({ fileName: 'mcpa-mailing-labels', appendDate: true });
            },
            exportOptions: {
              modifier: {
                selected: null
              },
              columns: ':visible',
              format: {
                body: function (data, row, column, node) {
                  return formatGridExport(data, column);
                }
              }
            } 
          },
          {
            extend: 'csvHtml5',
            text: '<i class="fal fa-file-csv"></i> CSV',
            titleAttr: 'Export to CSV',
            className: 'pao-dt-buttons',
            filename: function () {
              return formatExportFileName({ fileName: 'mcpa-search-export', appendDate: true });
            },
            exportOptions: {
              modifier: {
                selected: null
              },
              columns: ':visible',
              format: {
                body: function (data, row, column, node) {
                  return formatGridExport(data, column);
                }
              }
            } 
          },
          {
            extend: 'pdfHtml5',
            text: '<i class="fal fa-file-pdf"></i> PDF',
            titleAttr: 'Save As PDF',
            className: 'pao-dt-buttons',
            orientation: 'landscape',
            pageSize: 'A4',
            filename: function () {
              return formatExportFileName({ fileName: 'mcpa-search-export', appendDate: true });
            },
            exportOptions: {
              modifier: {
                selected: null
              },
              columns: ':visible',
              format: {
                body: function (data, row, column, node) {
                  return formatGridExport(data, column);
                }
              }
            }, 
            customize: function (doc) {
              doc['styles'] = {
                userTable: {
                  margin: [10, 5, 10, 5] 
                },
                header: {
                  bold: true,
                  color: "#000",
                  fillColor: "#2d4154",
                  fontSize: 14,
                  alignment: "center"
                },
                tableHeader: {
                  alignment: "center",
                  bold: true,
                  color: "#fff",
                  fillColor: "#2d4154",
                  fontSize: 9
                },
                tableFooter: {
                  bold: true,
                  color: "#000",
                  fillColor: "#2d4154",
                  fontSize: 11
                },
                title: {
                  bold: true,
                  color: "#000",
                  fillColor: "#2d4154",
                  fontSize: 14,
                  alignment: "center"
                },
                text: {
                  color: "#29A547",
                  fontSize: 8
                }
              };
              doc.defaultStyle.fontSize = 8;
              doc['footer'] = (function (currentPage, pageCount) {
                return {
                  columns: [
                    { text: formatExportFileName({ fileName: 'mcpa-search-export', appendDate: true }), alignment: 'left' },
                    { text: [{ text: currentPage.toString(), italics: false }, ' of ', { text: pageCount.toString(), italics: false }], alignment: 'right' }
                  ],
                  margin: [40, 5, 40, 5] 
                };
              });
            }
          },
          { 
            text: '<i class="far fa-mail-bulk"></i> Mailing Labels',
            className: 'pao-dt-buttons',
            modifier: {
              selected: null
            },
            action: function (e, dt, button, config) {
              let data = dt.buttons.exportData({
                columns: 0, 
                modifier: {
                  selected: null
                }
              });

              let parcelsData = {
                parids: [],
                file_name: formatExportFileName({ fileName: 'mailing-labels', appendDate: true })
              };
              let d = data.body;
              $.each(d, function (index, columnInfo) {
                parcelsData.parids.push(columnInfo[0]);
              });

              let json = JSON.stringify(parcelsData);

              let p1 = new Promise(function (resolve, reject) {
                if (checkDeviceBrand('Microsoft')) {
                  $('#pageInfo').addClass('progressWorking');
                  $('#pageInfo').html('Generating Mailing Lables&nbsp;&nbsp;<i class="far fa-spinner-third fa-spin"></i>');
                  resolve(exportLabels(json));
                } else {
                  exportLabels(json);
                }
              });
              p1.then(function (result) {
                $('#pageInfo').removeClass('progressWorking');
              });
              p1.catch(function (result) {
                $('#pageInfo').removeClass('progressWorking');
                $('#pageInfo').html(result);
              });
            } 
          }
        ]
      }
    ],
    colReorder: {
      enable: true
    },
    ordering: true,
    order: [[2, "asc"]], 
    language: {
      decimal: ".",
      thousands: ",",
      search:
        '<span style="color:#6699cc;font-size:1rem;font-weight:500"><i class="far fa-shovel"></i> Narrow results:</span>',
      emptyTable:
        '<span style="color:#6699cc;font-size:1rem;font-weight:500"><i class="fal fa-wine-glass"></i> No Data</span>'
    },
    columnDefs: [
      {
        responsivePriority: 1,
        targets: getColumnIndexesWithClass(data.cols, "PARCEL ID"),
        width: "4%",
        render: function (data, type, row, meta) {
          if (data !== null && type === "display" && data.length > 0) {
            let href =
              '<a href="' +
              location.origin +
              "/parcel/?parid=" +
              row[0] +
              '">' +
              row[0] +
              "</a>";
            data = href.replace("9999", row[0]);
          }
          return data;
        }
      },
      {
        responsivePriority: 2,
        targets: 1,
        width: "10%"
      }, 
      {
        responsivePriority: 2,
        targets: 2,
        width: "20%"
      }, 
      {
        responsivePriority: 3,
        targets: 3,
        width: "20%"
      }, 
      {
        responsivePriority: 4,
        targets: 4
      }
    ],
    info: false,
    scrollX: scrollObj,
    scrollY: function () {
      return ($(window).height() * 3.05) / 100 + "vh";
    },
    scrollCollapse: true,
    lengthMenu: [[5, 10, 15, 20, 25, 50, -1], [5, 10, 15, 20, 25, 50, "ALL"]],
    processing: true,
    stateSave: true, 
    stateDuration: -1, 
    drawCallback: function (settings) {
      let api = this.api();
      let info = api.page.info();
      let yies = info.recordsTotal > 1 || info.recordsTotal === 0 ? "ies" : "y";
      let $recordsMessage =
        info.recordsTotal >= 1000
          ? "Your search found more than 1,000 properties. Only the first 1,000 will be shown."
          : info.recordsTotal.toLocaleString() +
          " propert" +
          yies +
          " found in your search"; 
      $("#searchInfo").html($recordsMessage);
      $("#pageInfo").html(
        "Showing properties " +
        (info.start + (info.recordsTotal >= 1 ? 1 : 0)) +
        " to " +
        info.end +
        " for page " +
        (info.page + (info.recordsTotal >= 1 ? 1 : 0)) +
        " of " +
        info.pages
      );
    }
  }); 

  function formatGridExport(data, column) {
    let matchString = function (s, re) {
      s = s.replace(/(?:^|\n)/g, " ");
      let match = re.exec(s);
      if (match !== null) {
        return match[1];
      } else {
        return false;
      }
    }; 

    let regex, m;
    switch (column) {
      case 0: 
        regex = /<a [^>]+>([^<]+)<\/a>/;
        return matchString(data, regex);
      case 1: 
      case 4: 
        return data;
      case 2: 
        regex = /^.*data-content="\<div>\<ul\s*class=['|"]\w.*['|"]\><li>(.*)<\/li><\/ul><\/div>".*$/gmi;
        m = regex.exec(data);
        if (m !== null) {
          regex = /<li>/gmi;
          let str = m[1].replace(regex, "");
          regex = /<\/li>/gmi;
          str = str.replace(regex, "; ");
          return str;
        } else {
          regex = /title="(.*)">/gmi;
          let rtn = matchString(data, regex);
          if (!rtn) {
            return data;
          } else {
            return rtn;
          }
        }
      default:
        regex = /^.*data-content="\<div>\<ul\s*class=['|"]\w.*['|"]\><li>(.*)<\/li><\/ul><\/div>".*$/gmi;
        m = regex.exec(data);
        if (m !== null) {
          regex = /<li>/gmi;
          let str = m[1].replace(regex, "");
          regex = /<\/li>/gmi;
          str = str.replace(regex, "; ");
          return str;
        } else {
          regex = /title="(.*)">/gmi;
          let rtn = matchString(data, regex);
          if (!rtn) {
            return data;
          } else {
            return rtn;
          }
        }
    } 
  } 

  if (paoSearch.extraParams.MailQ === "export") {

    paoSearch.extraParams.MailQ = "exported";

    let table = $('#gridsearch').DataTable();

    table.button('1-1').trigger();


  } 

  $("#gridsearch_wrapper .dataTables_scrollBody").css({
    width: "100%",
    "overflow-x": "visible",
    "overflow-wrap": "break-word"
  });

  $("#gridsearch").on("mouseover", "td", function () {
    $('[data-toggle="popover"]')
      .popover({
        trigger: "hover focus click",
        role: "tooltip",
        html: true,
        offset: "2vh + 3%",
        placement: function (context, source) {
          let position = $(source).position();
          if (position.left > 515) {
            return "left";
          }
          if (position.left < 515) {
            return "right";
          }
          if (position.top < 110) {
            return "bottom";
          }
          return "top";
        },
        container: "body"
      })
      .on("show.bs.popover", function (e) {
        $("[rel=popover]")
          .not(e.target)
          .popover("hide");
        $(".popover").remove();
      });
    $("#gridsearch tbody").on("click", "tr", function () {
      let href = $(this)
        .find("a")
        .attr("href");
      if (href) {
        window.location = href;
      }
    });
  });

  resizeObjects();

} 

function getColumnIndexesWithClass(columns, className) {
  let indexes = [];
  $.each(columns, function (index, columnInfo) {
    let re = "/U\b" + className + "\bU/";
    if (re.match(columnInfo.title.toUpperCase())) {
      indexes.push(index);
    }
  });
  return indexes;
} 



function resizeObjects() {
  let h = $(window).height();
  $("#gridsearchBody").css({
    "min-height": (h * 3.95) / 100 + "vh",
    height: "100%"
  });
  let api = $("#gridsearch")
    .dataTable()
    .api();

  if (api) {
    let _pageLen = 5;
    if (h >= 576) _pageLen = 5; 
    if (h >= 768) _pageLen = 5; 
    if (h >= 992) _pageLen = 10; 
    if (h >= 1200) _pageLen = 10; 
    if (h >= 1900) _pageLen = -1; 

    let state = api.state.loaded();
    if (state) {
      _pageLen = state.length;
    }

    api.page.len(_pageLen).draw(false);

  }
} 

function getQuickSearchParts(q) {
  if (q.length > 0) {


    if (q !== 0 && q.length > 1) {

      q = decodeURIComponent(decodeURI(q));
      q = q.replace(new RegExp("\\+", "g"), " ").trim();

      let parts = q.split(" ");
      if (parts) {
        switch (parts.length) {
          case 0:
            break;
          case 1:
            if ($.isNumeric(parts[0])) {
              sessionStorage.setItem("ParcelId", parts[0] + "*");
            } else {
              sessionStorage.setItem("OwnLast", parts[0]);
            }
            break;
          default:
            if ($.isNumeric(parts[0])) {
              sessionStorage.setItem("Address", q);
            } else if (parts[0].slice(-1) == ",") {
              sessionStorage.setItem("OwnLast", parts[0].slice(0, -1));
              sessionStorage.setItem("OwnFirst", parts[1].trim() + "*");
            } else {
              sessionStorage.setItem("OwnLast", q);
            }
            break;
        }
      }
    }
    return true;
  }
} 

$(window).resize(function () {
  if (this.resizeTo) clearTimeout(this.resizeTo);
  this.resizeTo = setTimeout(function () {
    $(this).trigger("resizeEnd");
  }, 500);
}); 

$(window).on("resizeEnd", function () {
  resizeObjects();
}); 